import {
  CompassAPIMultiSeriesChartData,
  getCompassAPIChartData,
  getMultipleLineChartProps,
} from '../utils/compass'
import type { BaseContext } from './'
import { CommonChartConfig } from './common'

export namespace EnergyShortage {
  export namespace Overview {
    const CONTEXT_ID = 'equity:energy_shortage:overview'

    export const __typelist: {
      config: ChartConfig
      data: ChartData
      context: ContextType
    } = {} as any

    export type ContextType = BaseContext<
      typeof CONTEXT_ID,
      ChartConfig,
      ChartData
    >

    export interface ChartConfig extends CommonChartConfig {
      chart:
        | 'historical_shortage_risk'
        | 'default_user_mlt_percents_results'
        | 'default_user_prediction_results'
        | 'default_user_percentiles_results'
      context: typeof CONTEXT_ID
    }

    export type ChartData = CompassAPIMultiSeriesChartData

    export const Context: ContextType = {
      id: CONTEXT_ID,
      getChartId: (config) => `${config.context}:${config.chart}`,
      getChartData: getCompassAPIChartData,
      getChartProps: (config, data) => getChartProps(config, data),
    }

    const CHART_TITLES: Record<ChartConfig['chart'], string> = {
      historical_shortage_risk: 'Historical shortage risk',
      default_user_prediction_results: 'Monte-Carlo Deficit Probabilities',
      default_user_mlt_percents_results:
        'Threshold ENA MLT Percents for Deficit',
      default_user_percentiles_results: 'Threshold ENA percentiles for Deficit',
    }

    const getChartProps = (config: ChartConfig, data: ChartData) =>
      getMultipleLineChartProps(
        Context,
        {
          chartTitle: CHART_TITLES[config.chart],
          convertToPercentages: Array(data.data.length).fill(true),
          tooltip: { xDateFormat: '%B %Y' },
          xAxis: { labels: { format: '{value:%m/%y}' } },
        },
        { type: Array(data.data.length).fill('spline') }
      )(config, data)
  }
}
